export default __webpack_public_path__ + "static/media/alumni-icon.eee7375d.svg";